import React from 'react';
import PropTypes from 'prop-types';
import { DialogTitle, Box, Typography, IconButton, Badge } from '@mui/material';
import { Bell, X } from 'lucide-react';

const NotificationHeader = ({ notificationCount, onClose }) => (
  <DialogTitle sx={{ 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'space-between',
    borderBottom: '1px solid',
    borderColor: 'divider',
    pb: 2
  }}>
    <Box display="flex" alignItems="center" gap={1}>
      <Bell size={24} />
      <Typography variant="h6">
        Notifications
      </Typography>
      <Badge 
        badgeContent={notificationCount} 
        color="primary" 
        sx={{ ml: 1 }}
      />
    </Box>
    <IconButton onClick={onClose} size="small">
      <X size={20} />
    </IconButton>
  </DialogTitle>
);

NotificationHeader.propTypes = {
  notificationCount: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired
};

export default NotificationHeader;